export enum StockAvailableStatus {
  LIMITED = 'LIMITED',
  NORMAL = 'NORMAL',
  LOW = 'LOW'
}
